import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map, StorageUtil } from '../store';
import * as lodash from 'lodash';
import * as moment from 'moment';
import { max } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class DevelopmentCalendarService {
 
  url = '/api/developmentcalendar';
  constructor(
    private hs: HttpService
  ) { }

 
  loadDevelopmentCalendarPlayersByTeamID(teamID: number) {
    return this.hs.get(`${this.url}/load-development-calendar-players-team-id/${teamID}`);
  }
 
  loadDevelopmentCalendarByTeamAndPlayerID(teamID: number, playerID: number, selectedYear: number, selectedMonth: number) {
    return this.hs.get(`${this.url}/load-development-calendar-by-team-and-player-id/${teamID}/${playerID}/${selectedYear}/${selectedMonth}`);
  }

  loadDevelopmentCalendarByClubID(clubID: number, playerID: number, selectedYear: number, selectedMonth: number) {
    return this.hs.get(`${this.url}/load-development-calendar-by-club-id/${clubID}/${playerID}/${selectedYear}/${selectedMonth}`);
  }

  loadDevelopmentCalendarPlayerMood(teamID: number, playerID: number, selectedYear: number) {
    return this.hs.get(`${this.url}/load-development-calendar-player-mood/${teamID}/${playerID}/${selectedYear}`);
  }

  loadGameData(teamId: number, playerId: number, matchId: number) {
    return this.hs.get(`${this.url}/load-game-data/${teamId}/${playerId}/${matchId}`)
  }

  loadPracticeData(teamId: number, playerId: number, practiceId: number) {
    return this.hs.get(`${this.url}/load-practice-data/${teamId}/${playerId}/${practiceId}`)
  }

  loadInjuryData(injuryId: number) {
    return this.hs.get(`${this.url}/load-injury-data/${injuryId}`);
  }

  loadPlayerGameData(clubID, playerId, matchId: number) {
    return this.hs.get(`${this.url}/load-player-game-data/${clubID}/${playerId}/${matchId}`);
  }

  loadPlayerPracticeData(clubID: number, playerId: number, practiceId: number) {
    return this.hs.get(`${this.url}/load-player-practice-data/${clubID}/${playerId}/${practiceId}`);
  }

  loadPlayerMostCommonMood(playerId: number) {
    return this.hs.get(`${this.url}/most-common-mood/${playerId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/development-calendar.service .ts